export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 100 CARDS',
        cards: [
      {n:'1', name:'Luke Skywalker'},{n:'2', name:'Darth Vader'},{n:'3', name:'Obi-Wan Kenobi'},
      {n:'4', name:'Han Solo'},{n:'5', name:'Chewbacca'},{n:'6', name:'Lando Calrissian'},
      {n:'7', name:'Yoda'},{n:'8', name:'C-3PO'},{n:'9', name:'R2-D2'},{n:'10', name:'Boba Fett'},
      {n:'11', name:'Emperor Palpatine'},{n:'12', name:'X-wing Starfighters'},{n:'13', name:'Ben Kenobi'},
      {n:'14', name:'Attack on Hoth!'},{n:'15', name:'Battle with the Dianoga'},
      {n:'16', name:'PATROLLING the Cantina'},{n:'17', name:'Sandtrooper Atop a Dewback'},
      {n:'18', name:'The Skywalkers'},{n:'19', name:'Solo Investigates'},{n:'20', name:'Grand Moff Tarkin'},
      {n:'21', name:'Luke Skywalker in Action!'},{n:'22', name:'The Smuggler, Han Solo'},
      {n:'23', name:'Bounty Hunters'},{n:'24', name:'Salacious B. Crumb'},
      {n:'25', name:'A Card Game of Chance'},{n:'26', name:'Tusken Raider at Sundown'},
      {n:'27', name:'Medical Droid'},{n:'28', name:"Bounty Hunters Answer the Empire's Call"},
      {n:'29', name:'Wookiee War Dance'},{n:'30', name:'Boushh Disguise'},
      {n:'31', name:'Gamorrean Guard'},{n:'32', name:'Yoda on Dagobah'},
      {n:'33', name:'Life on Tatooine'},{n:'34', name:'Duel on the Death Star!'},
      {n:'35', name:'Princess Leia Organa'},{n:'36', name:'Ewoks Under Attack!'},
      {n:'37', name:"The Emperor's Power"},{n:'38', name:'X-wings in Formation'},
      {n:'39', name:'Yoda and Luke Skywalker'},{n:'40', name:'Stormtrooper Surveying the Desert'},
      {n:'41', name:'Aboard the Bridge'},{n:'42', name:'Han Solo & Chewbacca in the Cockpit'},
      {n:'43', name:'Snowtroopers Invade Hoth'},{n:'44', name:'Darth Vader VS. Obi-Wan Kenobi'},
      {n:'45', name:'Leia Organa in Her Boushh Disguise'},{n:'46', name:'The Dark Lord and a New Hope'},
      {n:'47', name:"Chewbacca's Anguish"},{n:'48', name:'A Wookiee in the Wilderness'},
      {n:'49', name:'A Galaxy Within Grasp'},{n:'50', name:'Enter: Darth Vader'},
      {n:'51', name:'The Skywalker Legacy'},{n:'52', name:'The Shadow of the Dark Lord'},
      {n:'53', name:'The Infamous Boba Fett'},{n:'54', name:'General Grievous'},
      {n:'55', name:'A Dark Turn for Anakin Skywalker'},{n:'56', name:"Mace Windu's Barrage!"},
      {n:'57', name:'Star Wars'},{n:'58', name:'Stormtroopers Swarm Darth Vader'},
      {n:'59', name:'Lord Vader & His Stormtroopers'},{n:'60', name:'Luke Skywalker on Endor'},
      {n:'61', name:'Boba Fett Ambushed!'},{n:'62', name:'An Enemy of the Empire'},
      {n:'63', name:'Stormtroopers Assess Their Gear'},{n:'64', name:"A Wookiee's Wrath"},
      {n:'65', name:'Luke Skywalker Assembles His Lightsaber'},{n:'66', name:'Creatures of the Cantina'},
      {n:'67', name:'The Jedi & The Princess'},{n:'68', name:'Wicket W. Warrick'},
      {n:'69', name:'The Boonta Eve Classic'},{n:'70', name:"Lord Vader Readies His Ship"},
      {n:'71', name:'Inside the Meditation Chamber'},{n:'72', name:'Wedge Antilles in Battle'},
      {n:'73', name:"Didn't Mean to Intrude"},{n:'74', name:'Lack of Faith'},
      {n:'75', name:'Tuskens & Their Bantha'},{n:'76', name:'Aayla Secura'},
      {n:'77', name:'Obi-Wan Kenobi & Boga'},{n:'78', name:'Qui-Gon Jinn'},
      {n:'79', name:"Galaxy's Greatest Scoundrels"},{n:'80', name:'Boba Fett Battles the Sarlacc!'},
      {n:'81', name:'Poe Dameron'},{n:'82', name:'Trudgen'},{n:'83', name:'Kylo Ren'},
      {n:'84', name:'Sith Trooper'},{n:'85', name:'Cobb Vanth'},{n:'86', name:'Leia Organa'},
      {n:'87', name:'Finn'},{n:'88', name:'Hunter'},{n:'89', name:'Echo'},
      {n:'90', name:'Crosshair'},{n:'91', name:'Wrecker'},{n:'92', name:'Tech'},
      {n:'93', name:'Omega'},{n:'94', name:'Weequay'},{n:'95', name:'Greedo'},
      {n:'96', name:'Bossk'},{n:'97', name:'Torra Doza'},{n:'98', name:'Hera Syndulla'},
      {n:'99', name:'Wedge Antilles'},{n:'100', name:'Anakin Skywalker'},
    ]
  },
  {
    id: 'promos', type: 'insert', title: 'PROMOTIONAL CARDS — 4 CARDS',
    parallels: [
      { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
      { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
      { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
      { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
      { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
      { id: 'purple', name: 'Purple Refractor', print_run: 25, color: '#b060ff' },
      { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
      { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
      { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
    ],
    cards: [
      {n:'P1', name:'Vintage Vader'},
      {n:'P2', name:'Docking Bay 94'},
      {n:'P3', name:'Man with a Mission'},
      {n:'P4', name:'Vader, Unplugged'},
    ]
  },
  {
    id: 'base-variations', type: 'insert', title: 'BASE CARD SKETCH VARIATIONS — 20 CARDS',
    cards: [
      {n:'BV-81', name:'Poe Dameron', artist:'Derek Laufman'},
      {n:'BV-82', name:'Trudgen', artist:'Derek Laufman'},
      {n:'BV-83', name:'Kylo Ren', artist:'Derek Laufman'},
      {n:'BV-84', name:'Sith Trooper', artist:'Derek Laufman'},
      {n:'BV-85', name:'Cobb Vanth', artist:'Derek Laufman'},
      {n:'BV-86', name:'Leia Organa', artist:'Derek Laufman'},
      {n:'BV-87', name:'Finn', artist:'Derek Laufman'},
      {n:'BV-88', name:'Hunter', artist:'Darrin Pepe'},
      {n:'BV-89', name:'Echo', artist:'Darrin Pepe'},
      {n:'BV-90', name:'Crosshair', artist:'Darrin Pepe'},
      {n:'BV-91', name:'Wrecker', artist:'Darrin Pepe'},
      {n:'BV-92', name:'Tech', artist:'Darrin Pepe'},
      {n:'BV-93', name:'Omega', artist:'Darrin Pepe'},
      {n:'BV-94', name:'Weequay', artist:'Jason Crosby'},
      {n:'BV-95', name:'Greedo', artist:'Jason Crosby'},
      {n:'BV-96', name:'Bossk', artist:'Jason Crosby'},
      {n:'BV-97', name:'Torra Doza', artist:'Daniel Govar'},
      {n:'BV-98', name:'Hera Syndulla', artist:'Daniel Govar'},
      {n:'BV-99', name:'Wedge Antilles', artist:'Daniel Govar'},
      {n:'BV-100', name:'Anakin Skywalker', artist:'Daniel Govar'},
    ]
  },
  {
    id: 'original-trilogy', type: 'insert', title: 'ORIGINAL TRILOGY CONCEPT ART — 10 CARDS',
    cards: Array.from({length: 10}, (_, i) => ({n:`OT-${i+1}`, name:`Original Trilogy Concept Art ${i+1}`}))
  },
  {
    id: 'retro-rewind', type: 'insert', title: 'RETRO REWIND — 15 CARDS',
    cards: [
      {n:'V-1', name:'Boba Fett', artist:'Star Wars: Droids'},
      {n:'V-2', name:'A Close Call!', artist:'Star Wars: Droids'},
      {n:'V-3', name:'On a Sand Skiff', artist:'Star Wars: Droids'},
      {n:'V-4', name:'Jessica Meade & Max Rebo', artist:'Star Wars: Droids'},
      {n:'V-5', name:'Admiral Screed', artist:'Star Wars: Droids'},
      {n:'V-6', name:"In Jord's Garage", artist:'Star Wars: Droids'},
      {n:'V-7', name:'The Fromm Gang', artist:'Star Wars: Droids'},
      {n:'V-8', name:'Mungo Baobab', artist:'Star Wars: Droids'},
      {n:'V-9', name:'Paploo', artist:'Star Wars: Ewoks'},
      {n:'V-10', name:'Chief Chirpa', artist:'Star Wars: Ewoks'},
      {n:'V-11', name:'Wicket W. Warrick', artist:'Star Wars: Ewoks'},
      {n:'V-12', name:'Dulok Shaman', artist:'Star Wars: Ewoks'},
      {n:'V-13', name:'Princess Kneesaa', artist:'Star Wars: Ewoks'},
      {n:'V-14', name:'Through the Bog', artist:'Star Wars: Ewoks'},
      {n:'V-15', name:'Wicket in Bright Tree Village', artist:'Star Wars: Ewoks'},
    ]
  },
  {
    id: 'gameplay-galaxy', type: 'insert', title: 'GAMEPLAY GALAXY — 25 CARDS',
    cards: [
      {n:'GG-1', name:'Star Wars: Empire at War'},
      {n:'GG-2', name:'Star Wars Jedi Knight II: Jedi Outcast'},
      {n:'GG-3', name:'Star Wars: Rebellion'},
      {n:'GG-4', name:'Star Wars: X-Wing vs. TIE Fighter'},
      {n:'GG-5', name:'Star Wars: X-Wing Tour of Duty: B-Wing'},
      {n:'GG-6', name:'Star Wars: Rebel Assault'},
      {n:'GG-7', name:'Star Wars: X-Wing'},
      {n:'GG-8', name:'Star Wars: The Empire Strikes Back'},
      {n:'GG-9', name:'Star Wars'},
      {n:'GG-10', name:'Star Wars: Battlefront II'},
      {n:'GG-11', name:'Star Wars: Republic Commando'},
      {n:'GG-12', name:'Star Wars: Battlefront'},
      {n:'GG-13', name:'Star Wars: Bounty Hunter'},
      {n:'GG-14', name:'Star Wars: Droidworks'},
      {n:'GG-15', name:'Star Wars Rogue Squadron III: Rebel Strike'},
      {n:'GG-16', name:'Star Wars: Starfighter'},
      {n:'GG-17', name:'Star Wars: Galactic Battlegrounds'},
      {n:'GG-18', name:'Star Wars: Demolition'},
      {n:'GG-19', name:'Star Wars: Force Commander'},
      {n:'GG-20', name:'Star Wars Jedi Knight: Mysteries of the Sith'},
      {n:'GG-21', name:'Star Wars: Shadows of the Empire'},
      {n:'GG-22', name:'Star Wars: Tie Fighter'},
      {n:'GG-23', name:'Star Wars: Super Bombad Racing'},
      {n:'GG-24', name:'Star Wars: Dark Forces'},
      {n:'GG-25', name:'Star Wars: Masters of Teräs Käsi'},
    ]
  },
  {
    id: 'auto-single', type: 'auto', title: 'GALAXY AUTOGRAPHS — 61 CARDS',
    cards: [
      {n:'GA-ABJ', name:'Ahmed Best'},{n:'GA-ABT', name:'Andrea Bartlow'},
      {n:'GA-AD', name:'Adam Driver'},{n:'GA-AGR', name:'Allan Graf'},
      {n:'GA-AK', name:'Andrew Kishino'},{n:'GA-BBU', name:'Bernard Bullen'},
      {n:'GA-BD', name:'Ben Diskin'},{n:'GA-BH', name:'Brian Herring'},
      {n:'GA-BL', name:'Billie Lourd'},{n:'GA-BM', name:'Ben Mendelsohn'},
      {n:'GA-CDW', name:'Corey Dee Williams'},{n:'GA-CH', name:'Clint Howard'},
      {n:'GA-CJ', name:'Carey Jones'},{n:'GA-CS', name:'Christopher Sean'},
      {n:'GA-DCB', name:'Dave Chapman'},{n:'GA-DMB', name:'Dominic Monaghan'},
      {n:'GA-DP', name:'David Pasquesi'},{n:'GA-DR', name:'Daisy Ridley'},
      {n:'GA-EW', name:'Ewan McGregor'},{n:'GA-GCP', name:'Gwendoline Christie'},
      {n:'GA-GE', name:'Giancarlo Esposito'},{n:'GA-GG', name:'Greg Grunberg'},
      {n:'GA-GTO', name:'Gina Torres'},{n:'GA-HC', name:'Hayden Christensen'},
      {n:'GA-HF', name:'Harrison Ford'},{n:'GA-IF', name:'Isla Farris'},
      {n:'GA-IM', name:'Ian McDiarmid'},{n:'GA-IS', name:'Isaac Singleton Jr.'},
      {n:'GA-JA', name:'Josef Altin'},{n:'GA-JBT', name:'Joanna Bennet'},
      {n:'GA-JC', name:'Jake Cannavale'},{n:'GA-JK', name:'Jamie King'},
      {n:'GA-JRO', name:'John Rosengrant'},{n:'GA-JS', name:'Jason Spisak'},
      {n:'GA-JT', name:'John Tui'},{n:'GA-KMT', name:'Kelly Marie Tran'},
      {n:'GA-KSN', name:'Kiran Shah'},{n:'GA-LD', name:'Laura Dern'},
      {n:'GA-LT', name:'Lee Towersey'},{n:'GA-MB', name:'Matt Berry'},
      {n:'GA-MBA', name:'Michonne Bourriague'},{n:'GA-ME', name:'Mike Edmonds'},
      {n:'GA-MM', name:'Mads Mikkelsen'},{n:'GA-MNW', name:'Ming-Na Wen'},
      {n:'GA-MR', name:'Misty Rosas'},{n:'GA-NA', name:'Naomi Ackie'},
      {n:'GA-NF', name:'Nika Futterman'},{n:'GA-NN', name:'Nick Nolte'},
      {n:'GA-OA', name:'Omid Abtahi'},{n:"GA-ODA", name:"Olivia d'Abo"},
      {n:'GA-PAR', name:'Philip Anthony-Rodriguez'},{n:'GA-PL', name:'Phil LaMarr'},
      {n:'GA-RAD', name:'Robin Atkin Downes'},{n:'GA-RD', name:'Rosario Dawson'},
      {n:'GA-SB', name:'Skyler Bible'},{n:'GA-SBL', name:'Steve Blum'},
      {n:'GA-TS', name:'Tiya Sircar'},{n:'GA-VM', name:'Vanessa Marshall'},
      {n:'GA-WD', name:'Warwick Davis'},{n:'GA-WEB', name:'W. Earl Brown'},
      {n:'GA-WH', name:'Werner Herzog'},
    ]
  },
  {
    id: 'auto-triple', type: 'auto', title: 'TRIPLE AUTOGRAPHS — 4 CARDS',
    parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}],
    cards: [
      {n:'TA-DAJ', name:'Daisy Ridley / Naomi Ackie / John Boyega', artist:'Rey / Jannah / Finn'},
      {n:'TA-EAW', name:'Alden Ehrenreich / Warwick Davis / Erin Kellyman', artist:'Han / Wicket / Enfys'},
      {n:'TA-FVT', name:'Taylor Gray / Vanessa Marshall / Freddie Prinze Jr.', artist:'Ezra / Hera / Kanan'},
      {n:'TA-HEI', name:'Ewan McGregor / Ian McDiarmid / Hayden Christensen', artist:'Obi-Wan / Palpatine / Anakin'},
    ]
  },
  {
    id: 'auto-dual', parallels: [{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'DUAL AUTOGRAPHS — 6 CARDS',
    cards: [
      {n:'DA-BL', name:'Brian Herring / Lynn Bruce Robertson', artist:''},
      {n:'DA-CM', name:'Ming-Na Wen / Carey Jones', artist:'Fennec / Cobb'},
      {n:'DA-DA', name:'Adam Driver / Daisy Ridley', artist:'Kylo / Rey'},
      {n:'DA-HE', name:'Hayden Christensen / Ewan McGregor', artist:'Anakin / Obi-Wan'},
      {n:'DA-MF', name:'Felicity Jones / Mads Mikkelsen', artist:'Jyn / Galen'},
      {n:'DA-TF', name:'Freddie Prinze Jr. / Tom Baker', artist:'Kanan / Baker'},
    ]
  },
  {
    id: 'sketch', parallels: [], type: 'sketch', title: 'SKETCH CARDS',
    cards: [{n:'SK-1', name:'Sketch Card', artist:'Various Artists'}]
  },
];
export const PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'purple', name: 'Purple Refractor', print_run: 25, color: '#b060ff' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const AUTO_PARALLELS = [
  { id: 'blue', name: 'Blue Refractor', print_run: 150, color: '#2979ff' },
  { id: 'green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
  { id: 'purple', name: 'Purple Refractor', print_run: 50, color: '#b060ff' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const INSERT_PARALLELS = [
  { id: 'green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
  { id: 'purple', name: 'Purple Refractor', print_run: 50, color: '#b060ff' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
